import { initialMetaForTable } from "constants/common";
import { getZipCodes } from "containers/leadcaremanager/api";
import { getTemplates } from "containers/templates/api";
import { capitalizeName, formatLocation } from "./common";

const {
  getHealthPlans,
  getStates,
  getCounties,
  getCities,
} = require("containers/policies/api");
const { debounce } = require("lodash");

const useDebouncedHealthPlansDataCallback = (delay = 700) => {
  return debounce(async (inputValue, resolve) => {
    if (!inputValue.trim()) {
      resolve([]);
      return;
    }

    try {
      const response = await getHealthPlans({ search: inputValue });

      const formattedOptions =
        response?.health_plans?.map((manager) => ({
          label: capitalizeName(manager.name),
          value: manager.id,
        })) || [];

      resolve(formattedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
      resolve([]);
    }
  }, delay);
};

const useDebouncedStatesDataCallback = (delay = 700) => {
  return debounce(async (inputValue, resolve) => {
    if (!inputValue.trim()) {
      resolve([]);
      return;
    }

    try {
      const response = await getStates({ search: inputValue });

      let formattedOptions =
        response?.states?.map((manager) => ({
          label: manager.name.toUpperCase(),
          value: manager.id,
        })) || [];

      resolve(formattedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
      resolve([]);
    }
  }, delay);
};

const useDebouncedCountiesDataCallback = (delay = 700) => {
  return debounce(async (inputValue, stateId, resolve) => {
    if (!inputValue.trim()) {
      resolve([]);
      return;
    }

    try {
      const response = await getCounties({
        search: inputValue,
        state_id: stateId,
      });

      let formattedOptions =
        response?.counties?.map((manager) => ({
          label: formatLocation(manager.name),
          value: manager.id,
        })) || [];

      resolve(formattedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
      resolve([]);
    }
  }, delay);
};
const useDebouncedCitiesDataCallback = (delay = 700) => {
  return debounce(async (inputValue, stateId, countyId, resolve) => {
    if (!inputValue.trim()) {
      resolve([]);
      return;
    }

    try {
      const response = await getCities({
        search: inputValue,
        state_id: stateId,
        county_id: countyId,
      });

      let formattedOptions =
        response?.cities?.map((manager) => ({
          label: capitalizeName(manager.name),
          value: manager.id,
        })) || [];

      resolve(formattedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
      resolve([]);
    }
  }, delay);
};
const useDebouncedZipCodesDataCallback = (delay = 700) => {
  return debounce(async (inputValue, stateId, countyId, cityId, resolve) => {
    if (!inputValue.trim()) {
      resolve([]);
      return;
    }

    try {
      const response = await getZipCodes({
        search: inputValue,
        state_id: stateId,
        county_id: countyId,
        city_id: cityId,
      });

      let formattedOptions =
        response?.zip_codes?.map((code) => ({
          label: code.code,
          value: code.id,
        })) || [];

      resolve(formattedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
      resolve([]);
    }
  }, delay);
};
const useDebouncedTemplateDataCallback = (delay = 700) => {
  return debounce(async (inputValue, resolve) => {
    if (!inputValue.trim()) {
      resolve([]);
      return;
    }

    try {
      const response = await getTemplates({
        ...initialMetaForTable,
        search: inputValue,
      });

      const formattedOptions =
        response?.templates?.map((manager) => ({
          label: manager.name,
          value: manager.id,
        })) || [];

      resolve(formattedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
      resolve([]);
    }
  }, delay);
};
export {
  useDebouncedHealthPlansDataCallback,
  useDebouncedTemplateDataCallback,
  useDebouncedStatesDataCallback,
  useDebouncedCountiesDataCallback,
  useDebouncedCitiesDataCallback,
  useDebouncedZipCodesDataCallback,
};
